import type { Appointment } from "@/types/appointments/api-types/appointment-types";
import type { Sale } from "@/types/sales/api-types/sale-types";

export interface ClientAppointmentVisitLine {
  key: string;
  name: string;
  staff_name: string | null;
  price: number;
}

export const sortSalesNewestFirst = (sales: Sale[]): Sale[] =>
  [...sales].sort((a, b) => {
    if (a.appointment_date !== b.appointment_date) {
      return a.appointment_date < b.appointment_date ? 1 : -1;
    }
    return b.id - a.id;
  });

export const sortAppointmentsSoonestFirst = (
  appointments: Appointment[]
): Appointment[] =>
  [...appointments].sort((a, b) => {
    if (a.appointment_date !== b.appointment_date) {
      return a.appointment_date < b.appointment_date ? -1 : 1;
    }
    return a.id - b.id;
  });

export const earliestServiceStartTime = (
  services: { start_time: string }[]
): string | null => {
  const starts = services.map((line) => line.start_time).filter(Boolean);
  if (starts.length === 0) return null;
  return starts.reduce((earliest, time) =>
    time < earliest ? time : earliest
  );
};

export const historyVisitLines = (sale: Sale): ClientAppointmentVisitLine[] => [
  ...sale.services.map((line) => ({
    key: `service-${line.id}`,
    name: line.service_name ?? "",
    staff_name: line.staff_name,
    price: line.price,
  })),
  ...sale.products.map((line) => ({
    key: `product-${line.id}`,
    name: line.product_name ?? "",
    staff_name: line.staff_name,
    price: line.price,
  })),
];

export const upcomingVisitLines = (
  appointment: Appointment
): ClientAppointmentVisitLine[] =>
  appointment.services.map((line) => ({
    key: `service-${line.id}`,
    name: line.service_name ?? "",
    staff_name: line.staff_name,
    price: line.price,
  }));

export const clientAppointmentFormKey = (ids: number[]): string =>
  ids.join("-");
